module.exports = __webpack_public_path__ + "img/Alana_Branston.69e5925b.jpeg";